// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".data-list-empty[data-v-2396c0a5]{width:100%;padding-top:37.333vw;text-align:center;color:rgba(0,0,0,.6);font-size:3.733vw}.data-list-empty img[data-v-2396c0a5]{width:47.2vw}", ""]);
// Exports
module.exports = exports;
